import React, { useContext, useState } from "react";
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import classes from "./shared.module.css";
import { darVoz, pedirVoz, borrarVoz } from "../../../giveVoiceComp/Tabs/api"
import { vocesTotalesByOrigen } from "../../../dasboard/api"
import { useSkillList } from "./../../context/useSkillList";
import { vozavosContext } from "../../../vozavosContext";
import iconHeaderModalOk from "../../../../components/home/assets/Grupo 1188.svg";
import iconHeaderModalError from "../../../../components/home/assets/ilustracion-errores.svg";
import "./SubmitButtonsWrapper.css";
import { sendEmail } from "../../../../ApiLogicApp";
import SubmitLoader from "./SubmitLoader";
import PeoplePicker from "../../../SearchBar/PeoplePicker";

const MENSAJE_SIN_COMPETENCIA = 'Advertencia: Debes seleccionar mínimo una competencia.';
const MENSAJE_SIN_COMENTARIO = 'Advertencia: Debes dejar un comentario a tu compañero.';
const MENSAJE_SIN_COMPANERO = 'Advertencia: Debes seleccionar un compañero.';
const MENSAJE_AUTO_VOZ = 'Advertencia: No es posible darte una Voz a ti mismo.';
const MENSAJE_REGALO_INVALIDO = 'Advertencia: Debes enviar un link de una página web.';
const DEMORA_RECARGA_MS = 2000;
const URL_BASE = 'https://www.vozavos.com.co';

const crearItemCompetencia = (competencia) =>
  '<li style="margin-top: 0px;margin-bottom: 0;margin-left: 0;">' + competencia + "</li>";

const SubmitButtonsWrapper = (props) => {

  const { typeButton, setCheckPill, setCheckPillSkill, setComment, setTextGift, setCompanero,
    fnErrorCompetencias, fnErrorCompannero, fnErrorComentario, fnErrorRegalo, peopleSelected, comment, gift, id, scrollTo } = props;
  const { getArrayList, getArrayListDarVoz, getRegalo, resetTextArea, resetArrayList } = useSkillList();
  const { state: { mail, userName } } = useContext(vozavosContext);

  const [modal, setModal] = useState(false);
  const [modalEsencia, setModalEsencia] = useState(false);
  const [modalError, setModalError] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const className = "modalcontent";
  let nombreAsunto = userName, targetName = "", descripcionVoz = "", competencias = "", footerText = "", descripcionAsunto = "", subjectDescription = "", url = "", descripcion = "", btn = "", giftText = "";

  const toggle = () => setModal(!modal);
  const toggleEsencia = () => setModalEsencia(!modalEsencia);
  const toggleError = () => setModalError(!modalError);

  const allToggle = () => {
    setModalEsencia(!modalEsencia);
    setModal(!modal);
  };
  const closeBtn = <button className="closeButton" data-testid="closeButton" onClick={toggle}></button>;
  let titleModal = "Enviar Voz";
  let messageModal1 = 'Vemos que has marcado algunas competencias de tu compañero como “Excelentes”.';
  let messageModal2 = '¿Quisieras de paso darle un reconocimiento en Nuestra Esencia?';
  let mensajeConfirmacion = 'Tu Voz ha sido enviada correctamente.';
  let loadingMessage = "Enviando tu Voz...";

  if (typeButton === 'pedirVoz') {
    titleModal = 'Pedir Voz';
    mensajeConfirmacion = peopleSelected.length === 1 ? 'Tu Voz ha sido solicitada correctamente.' : 'Tus Voces han sido solicitadas correctamente.';
    loadingMessage = peopleSelected.length === 1 ? "Solicitando tu Voz..." : "Solicitando tus Voces...";

  }
  const funcionBorradoVoz = async (idVoz, limite = 3) => {
    let resp = await borrarVoz(idVoz)
    limite--;
    if (resp !== '' && limite > 0) {
      return funcionBorradoVoz(idVoz, limite)
    }
    return "";
  }
  const splitName = async (nombre, tipo) => {
    let arrayNombre = nombre.replace(" de ", " ").replace(" del ", " ").replace(" los ", " ").replace(" De ", " ").replace(" Del ", " ").replace(" Los ", " ").split(" ");
    if (tipo === "saludo") {
      return arrayNombre[0];
    } else {
      if (arrayNombre.length === 4)
        return arrayNombre[0] + " " + arrayNombre[2];
      else return arrayNombre[0] + " " + arrayNombre[1];
    }
  };
  const enviarCorreo = async (descripcionAsuntoCorreo, nombreDestino) => {
    nombreAsunto = await splitName(nombreAsunto, "otro");
    targetName = await splitName(nombreDestino.text, "saludo");
    subjectDescription = nombreAsunto + descripcionAsuntoCorreo;
    await sendEmail(nombreAsunto, targetName, nombreDestino.tertiaryText.toLowerCase(), descripcionVoz, competencias, footerText, subjectDescription, url, descripcion, btn, giftText);
  };
  // Valida los datos de "dar voz", avisa de cada error y devuelve true si hay alguno.
  const validarDarVoz = (arrayExcelente, arrayBueno, arrayAdecuado, arrayMejorar) => {
    let error = false;
    if (arrayExcelente.length === 0 && arrayBueno.length === 0 && arrayAdecuado.length === 0 && arrayMejorar.length === 0) {
      fnErrorCompetencias(MENSAJE_SIN_COMPETENCIA);
      scrollTo("errorCompetencias")
      error = true;
    }
    if (descripcion === '') {
      fnErrorComentario(MENSAJE_SIN_COMENTARIO);
      scrollTo("errorComentario")
      error = true;
    }
    if (peopleSelected.length === 0) {
      fnErrorCompannero(MENSAJE_SIN_COMPANERO);
      scrollTo("errorCompannero");
      error = true;
    }
    if (peopleSelected.length > 0 && peopleSelected[0].tertiaryText === mail) {
      fnErrorCompannero(MENSAJE_AUTO_VOZ);
      scrollTo("errorCompannero");
      error = true;
    }
    if (gift.length > 0 && gift.includes("http") === false) {
      fnErrorRegalo(MENSAJE_REGALO_INVALIDO);
      scrollTo("errorRegalo");
      error = true;
    }
    return error;
  };

  // Valida los datos de "pedir voz", avisa de cada error y devuelve true si hay alguno.
  const validarPedirVoz = (arrayDarVoz) => {
    let error = false;
    if (arrayDarVoz.length === 0) {
      fnErrorCompetencias(MENSAJE_SIN_COMPETENCIA);
      scrollTo("errorCompetencias");
      error = true;
    }
    if (peopleSelected.length === 0) {
      fnErrorCompannero(MENSAJE_SIN_COMPANERO);
      scrollTo("errorCompannero");
      error = true;
    }
    if (peopleSelected.length > 0 && peopleSelected[0].tertiaryText === mail) {
      fnErrorCompannero(MENSAJE_AUTO_VOZ);
      scrollTo("errorCompannero");
      error = true;
    }
    return error;
  };

  // Arma el contenido del correo de "dar voz" en las variables del componente que usa enviarCorreo.
  const prepararCorreoDarVoz = (arrayExcelente, arrayBueno, arrayAdecuado, arrayMejorar) => {
    const totalCompetencias = arrayExcelente.length + arrayBueno.length + arrayMejorar.length + arrayAdecuado.length;
    descripcionVoz = totalCompetencias === 1 ? 'te ha <strong style="color: #4132b4">dado una Voz</strong> en la competencia:' : 'te ha <strong style="color: #4132b4">dado una Voz</strong> en las competencias:';
    descripcionAsunto = " te ha dado una Voz";
    // Orden de las competencias en el correo: excelente, bueno, mejorar y adecuado.
    [arrayExcelente, arrayBueno, arrayMejorar, arrayAdecuado].forEach(lista => lista.forEach(competencia => competencias += crearItemCompetencia(competencia)));
    footerText = 'Ingresa a <strong style="color: #4132b4">Voz a vos</strong>, visualiza en el <strong style="color: #4132b4">dashboard</strong> qué insumos tienes para tu plan de desarrollo y anímate a pedir más voces.';
    btn = "¡Ir a Voz a vos!"
    giftText = `<p style="text-align: left; padding-left: 20px; padding-right: 20px;">Tu compañero te ha dejado un regalo para tu desarrollo, ingresa al siguiente enlace para descubrirlo. <br><a href="${gift}">${gift}</a></p>`
  };

  // Avisos en blanco, lista de compañeros vacía y recarga de la página a los 2 segundos.
  const limpiarAvisosYRecargar = () => {
    fnErrorComentario('');
    fnErrorCompetencias('')
    fnErrorCompannero('');
    setCompanero([]);
    setTimeout(() => {window.location.reload();}, DEMORA_RECARGA_MS);
  };

  const finalizarDarVoz = async (arrayExcelente) => {
    await enviarCorreo(descripcionAsunto, peopleSelected[0]);
    setShowLoader(false);
    if (arrayExcelente.length > 0) {
      toggleEsencia();
    } else {
      toggle();
    }
    resetTextArea();
    resetArrayList('todos');
    setCheckPill(false);
    setCheckPillSkill(false);
    setComment('');
    setTextGift('');
    limpiarAvisosYRecargar();
  };

  const procesarDarVoz = async () => {
    const arrayExcelente = getArrayList('excelente');
    const arrayBueno = getArrayList('bueno');
    const arrayAdecuado = getArrayList('adecuado');
    const arrayMejorar = getArrayList('mejorar');
    // enviarCorreo lee esta descripción del componente, por eso se asigna a la variable externa.
    descripcion = comment;

    prepararCorreoDarVoz(arrayExcelente, arrayBueno, arrayAdecuado, arrayMejorar);
    if (validarDarVoz(arrayExcelente, arrayBueno, arrayAdecuado, arrayMejorar)) return;

    const regaloDarVoz = getRegalo();
    setShowLoader(true);
    const res = await darVoz([], arrayExcelente, arrayBueno, arrayAdecuado, arrayMejorar, descripcion, regaloDarVoz, mail.toLowerCase(), userName, peopleSelected[0].tertiaryText.toLowerCase(), peopleSelected[0].text, id);
    url = `${URL_BASE}/myvoices/${res}`;

    // Comparación laxa conservada: una respuesta undefined cuenta como guardada.
    if (res != '') {
      await finalizarDarVoz(arrayExcelente);
    }
    else {
      setModalError(!modalError);
    }
  };

  // Solicita una voz a cada persona, en orden, y se detiene en la primera que falle.
  const guardarVocesPedidas = async (arrayDarVoz) => {
    const arrFechas = [];
    let errorGuardarVoz;
    for (const person of peopleSelected) {
      const fechaCreacion = new Date().toISOString();
      arrFechas.push(fechaCreacion);
      const res = await pedirVoz(arrayDarVoz, comment, person.tertiaryText.toLowerCase(), userName, mail.toLowerCase(), person.text, fechaCreacion);
      url = `${URL_BASE}/givevoice/${res}`;
      if (res == '') {
        errorGuardarVoz = true;
        break;
      }
    }
    return { errorGuardarVoz, arrFechas };
  };

  // Si alguna solicitud falló, borra las voces creadas en esa tanda (con reintentos) y avisa del error.
  const revertirVocesPedidas = async (arrFechas) => {
    const filter = {
      origen: mail.toLowerCase(),
      sortDirection: "DESC",
      createdAt: { "between": [arrFechas[0], arrFechas[arrFechas.length - 1]] }
    };
    const arrVocesEnviadas = await vocesTotalesByOrigen(filter, userName, mail);
    if (arrVocesEnviadas.length > 0) {
      for (const obj of arrVocesEnviadas) {
        const resp = await borrarVoz(obj.id);
        if (resp !== '') {
          await funcionBorradoVoz(obj.id);
        }
      }
    }
    setShowLoader(false);
    setModalError(!modalError);
  };

  const finalizarPedirVoz = () => {
    setShowLoader(false);
    toggle();
    resetTextArea();
    resetArrayList('');
    setCheckPill(false);
    setCheckPillSkill(false);
    setComment(' ');
    limpiarAvisosYRecargar();
  };

  const procesarPedirVoz = async () => {
    const arrayDarVoz = getArrayListDarVoz();
    descripcionVoz = arrayDarVoz.length === 1 ? 'te ha enviado una <strong style="color: #4132b4">solicitud de Voz</strong> en la competencia:' : 'te ha enviado una <strong style="color: #4132b4">solicitud de Voz</strong> en las competencias:';
    descripcionAsunto = " te ha solicitado una Voz";
    arrayDarVoz.forEach(competencia => competencias += crearItemCompetencia(competencia));
    footerText = 'Recuerda que al <strong style="color: #4132b4">darle tu Voz</strong> a un compañero estás contribuyendo significativamente en su <strong style="color: #4132b4">desarrollo personal y profesional.</strong>';
    btn = "¡Ir a la voz!";

    if (validarPedirVoz(arrayDarVoz)) return;

    setShowLoader(true);
    const { errorGuardarVoz, arrFechas } = await guardarVocesPedidas(arrayDarVoz);
    if (errorGuardarVoz) {
      await revertirVocesPedidas(arrFechas);
      return;
    }

    finalizarPedirVoz();
    for (const person of peopleSelected) {
      await enviarCorreo(descripcionAsunto, person);
    }
  };

  const voz = async () => {
    setBtnDisabled(true);
    if (typeButton === 'darvoz') { //dar voz
      await procesarDarVoz();
    }
    else { //pedir voz
      await procesarPedirVoz();
    }
    setBtnDisabled(false);
  };
  return (
    <div className={classes.submitButtonsWrapper}>
      <Button disabled={btnDisabled} className={classes.submitionBtn} data-testid="buttonModal" onClick={() => voz()}>{titleModal}</Button>

      <Modal isOpen={showLoader} contentClassName={className} centered={true} backdrop="static">
        <ModalHeader className="prueba modal-title-Cargando">
          <SubmitLoader tipoVoz={loadingMessage} />
        </ModalHeader>
      </Modal>
      <Modal isOpen={modalEsencia} toggle={toggleEsencia} contentClassName={className} centered={true} backdrop="static">
        <ModalHeader className="prueba modal-title-Excelente" toggle={toggleEsencia} close={closeBtn}>
          <div>
            <img className="modalHeaderIcon" src={iconHeaderModalOk} alt="Ícono modal ok" />
          </div>
          <div className="divHeaderExce">
            <div className="divBodyText">
              {messageModal1}
            </div>
            <div className="divBodyText">
              {messageModal2}
            </div>
          </div>
        </ModalHeader>
        <ModalBody className="modalBody">
          <div>
            <button className={classes.cancelBtn} onClick={allToggle} data-testid="soloEnviar">No, solo enviar Voz</button>
            <a href="https://nuestraesencia.plandereconocimientos.com/pages/login" target="_blank" rel="noopener noreferrer"><button className={classes.submitionBtn} onClick={allToggle}>¡Si claro!</button></a>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={modal} toggle={toggle} contentClassName="modalcontentNoExcelente" centered={true} backdrop="static">
        <ModalHeader className="prueba" toggle={toggle} close={closeBtn}>
          <div>
            <img className="modalHeaderIcon" src={iconHeaderModalOk} alt="Ícono modal ok" />
          </div>
          <div className="divHeaderImage">
            <div className="divBodyTextNoExce">{mensajeConfirmacion}</div>
          </div>
        </ModalHeader>
        <ModalBody className="modalBody">
          <button className={classes.submitionBtn} onClick={toggle}>Cerrar</button>
        </ModalBody>
      </Modal>
      <Modal isOpen={modalError} toggle={toggleError} contentClassName="modalcontentNoExcelente" centered={true} backdrop="static">
        <ModalHeader className="prueba" toggle={toggleError} close={closeBtn}>
          <div>
            <img className="modalHeaderIcon" src={iconHeaderModalError} alt="Ícono modal error" />
          </div>
          <div className="divHeaderImageError">
            <div className="divBodyText">No se pudo guardar tu Voz, por favor intenta de nuevo.</div>
          </div>
        </ModalHeader>
        <ModalBody className="modalBody">
          <button className={classes.submitionBtn} onClick={toggleError}>Cerrar</button>
        </ModalBody>
      </Modal>
      {/* <button className={classes.cancelBtn}>Cancelar</button> */}

    </div>
  );
};
export default SubmitButtonsWrapper;